import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'beautify' })
export class BeautifyPhonePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      if (value.startsWith('+4021')) {
        if (value.length === 9)
          return '021 ' + value.substring(5).match(/.{1,4}/g).join(' ');
        else
          return value.substring(2).match(/.{1,3}/g).join(' ');
      } else {
        return '0' + value.substring(3).match(/.{1,3}/g).join(' ');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/pipes/beautify-phone.pipe.ts